<template>
  <div>
    <nav-bar/>
    <div class="container-fluid">
    <div class="row">
      <div class="col-6 pr-1 pl-2">
        <div class="mt-2 card">
          <h3 class="font-grey kne-title">{{$t('Dashboard.new_note_title')}}</h3>
          <regular-textarea
            :value="note.text"
            @input="note.text = $event"
            :placeholder="$t('Dashboard.new_note_message')" class="p-2" rows="4"/>
          <div class="container pb-2">
            <div class="row">
              <regular-input
                :value="note.name"
                @input="note.name = $event"
                :placeholder="$t('Dashboard.new_note_name')" class="col-12 col-md-6 pl-2 pr-1"/>
              <div class="col-12 col-md-6 pr-2 pl-1">
                <button class="btn btn-kne-orange w-100" :disabled="!noteFilled" @click="send()">
                  {{$t('General.send')}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 card">
          <h3 class="kne-title">{{$t('Dashboard.statistic_title')}}</h3>
          <div class="w-100">
            <bar-chart 
            :chart-data="{labels: [$t('OrderCurrent.stats.processing'), $t('OrderCurrent.stats.dispatch'), $t('OrderCurrent.stats.pick'), $t('OrderCurrent.stats.transit'), $t('OrderCurrent.stats.delivered'), $t('OrderCurrent.stats.transferred'), $t('OrderCurrent.stats.rejected')], datasets: [{ label: $t('OrderCurrent.title'), backgroundColor: ['#f7941e', '#ff5151', '#515eff', '#43de8f', '#de438b', '#43d7de', '#decb43', '#d46a6a'], data: [count.processing, count.dispatch, count.pick, count.transit, count.drop, count.transfer, count.reject]}]}"
            :options="{responsive: true, maintainAspectRatio: false}">
            </bar-chart>
          </div>
        </div>
      </div>
      <div class="col-6 pl-1 pr-2">
        <div class="mt-2 card">
          <h3 class="font-grey kne-title">{{$t('Dashboard.notes_title')}}</h3>
          <paginate-links for="reversedNotes" :hide-single-page="true" :limit="5"></paginate-links>
          <paginate name="reversedNotes" tag="div" :list="reversedNotes" class="" :per="12">
            <transition-group name="fade" tag="div">
              <div v-for="note in paginated('reversedNotes')" class="card-block p-3 message" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + note['.key']" aria-expanded="true" :aria-controls="'#collapse' + note['.key']" :key="note['.key']">
                <div :id="'collapse' + note['.key']" class="collapse" role="tabpanel" aria-labelledby="headingOne">
                  <p class="text-justify">{{note.text}}</p>
                </div>
                <p class="header font-grey">
                  <i>{{note.name}}</i>
                  <i class="pull-right">{{ getDate(note.date)}}</i>
                </p>
              </div>
            </transition-group>
          </paginate>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import barChart from '../module/barChart.js'
import regularTextarea from '../regularTextarea.vue'
import regularInput from '../regularInput.vue'
import {db} from '../../firebase'
export default {
  name: 'Dashboard',
  components: {
    barChart,
    regularTextarea,
    regularInput
  },
  data () {
    return {
      count: {
        processing: 0,
        dispatch: 0,
        pick: 0,
        transit: 0,
        drop: 0,
        transfer: 0,
        reject: 0
      },
      note: {
        text: '',
        name: '',
        date: ''
      },
      current: [],
      notes: [],
      reversedNotes: [],
      paginate: ['reversedNotes']
    }
  },
  created () {
    this.$bindAsArray('current', db.ref('test/transporter/' + this.companyUID + '/deliveries/'), null, () => {
      this.counts()
    })
    this.$bindAsArray('notes', db.ref('database/transporter/' + this.companyUID + '/notes/'), null, () => {
    })
  },
  computed: {
    noteFilled () {
      if (this.note.text !== '' && this.note.name !== '') return true
      else return false
    },
    companyUID () {
      return this.$store.state.authorization.company
    }
  },
  methods: {
    counts () {
      for (var attr in this.count) this.count[attr] = 0
      this.current.forEach((o) => {
        if (o.status === 'Processing') this.count.processing++
        if (o.status === 'Dispatch') this.count.dispatch++
        if (o.status === 'Pick') this.count.pick++
        if (o.status === 'Transit') this.count.transit++
        if (o.status === 'Drop') this.count.drop++
        if (o.status === 'Transférée') this.count.transfer++
        if (o.status === 'Reject') this.count.reject++
      })
    },
    send () {
      this.note.date = Date.now()
      db.ref('database/transporter/' + this.companyUID + '/notes/').push().set(this.note).then(() => {
        for (var attr in this.note) {
          this.note[attr] = ''
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  },
  watch: {
    current: function () {
      this.counts()
    },
    notes: function (snapshot) {
      this.reversedNotes = JSON.parse(JSON.stringify(snapshot))
      this.reversedNotes.reverse()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?46c13037